import React from 'react';
import {Dropdown, Menu} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import {uuid} from "../../../utils";

/**
 * creat by xcc
 * @description 按钮+下拉组合按钮
 */

export default class BtnGroup extends BaseComponent {
    static propTypes = {};
    static defaultProps = {
        menuStyle: {
            width: 120
        },
        menuData: [
            {
                name: "",
                onClick: () => {
                }
            }
        ],
        btnName: "",
        placement: "bottomRight",
        type: "primary",
    };

    constructor(props) {
        super(props);
        this.state = {
            buttonWidth: 0,
            uniqueKey: uuid()
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.updateButtonWidth();
    }

    updateButtonWidth = () => {
        const button = document.querySelector(`.btnGroup-${this.state.uniqueKey} .ant-btn-group .ant-btn`);
        if (button) {
            this.setState({ buttonWidth: button.offsetWidth + 33 });
        }
    };

    getMenu() {
        const {menuData = [], menuStyle = {}} = this.props;
        const { buttonWidth } = this.state;
        return (
            <Menu style={{...menuStyle, width: buttonWidth}} id={"menu"}>
                {menuData.map((item, index) => {
                    if(item.show !== false){
                        return (   
                            <Menu.Item key={index}  onClick={() => {
                                 item.onClick()
                             }}>{item.name}</Menu.Item>                       
                         )
                    }
                   
                })}
                <style>{`
                    #menu .ant-dropdown-menu-item{padding: 5px 17px;}
                `}</style>
            </Menu>
        )
    }

    render() {
        const menu = this.getMenu();
        const {onClick, placement, btnName, type} = this.props;
        return (
            <div className={`btnGroup btnGroup-${this.state.uniqueKey}`}>
                <Dropdown.Button
                    onClick={onClick}
                    type={type}
                    overlay={menu}
                    placement={placement}
                >
                    {btnName}
                </Dropdown.Button>
                <style>{`.btnGroup .ant-btn-group .ant-btn + .ant-btn{margin-left: 1px;}`}</style>
            </div>
        )
    }
}